
const Profile = () => {
    return (
        <div className="min-h-screen">
            <h1>Perfil</h1>
            <p>Tu historial de compras y detalles del perfil.</p>
        </div>
    );
}

export default Profile;
